import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-page-block-text',
  templateUrl: './event-page-block-text.component.html',
  styleUrls: ['./event-page-block-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventPageBlockTextComponent implements OnInit {

  @Input() block = null;
  @Input() index = null;

  public id = '';

  constructor() { }

  ngOnInit(): void {
    this.id = `text-${this.index}`
  }

}
